import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { generatePdf } from './pdfGenerator';
import { getUserDetails } from './session-service';

export async function getAll() {
    const response = await apiGet('core', `risk-assessment`);
    return response;
}

export async function getRiskTaskReport(id: number) {
    const response = await apiGet('core', `risk-job-step-report/${id}`);
    // await generatePdf(response?.content?.html)
    return response?.content?.html;
}

export async function getRiskAssessmentReport() {
    const response = await apiGet('core', `risk-job-step-report`);
    // await generatePdf(response?.content?.html)
    return response?.content?.html;
}

export async function getRiskAssessment(id?: string) {
    const response = await apiGet('core', `risk-assessment/${id}`);
    return response.content;
}


export async function addRiskAssessment(newDetails: any) {
    const response = await apiPost('core', `risk-assessment`, newDetails);
    return response;
}

export async function addEquipmentRiskAssessment(equipmentId: string, riskId: number) {
    const response = await apiPut('core', `equipment-risk-assessment`, {
        equipment: equipmentId,
        risk_assessment: riskId
    });
    return response;
}

export async function updateRiskAssessment(newDetails: any, id?: string) {
    if (!id) {
        id = getUserDetails().client_id;
    }
    const response = await apiPut('core', `risk-assessment/${id}`, newDetails);

    return response;
}

export async function removeRiskAssessment(id: any) {
    return await apiDelete('core', `risk-assessment/${id}`);
}


export async function addRiskJobTask(newDetails: any) {
    const response = await apiPost('core', `risk-job-task`, newDetails);
    return response;
}

export async function addSiteRiskJobTask(newDetails: any) {
    const response = await apiPost('core', `site-job-task`, newDetails);
    return response;
}

export async function updateRiskJobTask(newDetails: any, id?: string) {
    if (!id) {
        id = getUserDetails().client_id;
    }
    const response = await apiPut('core', `risk-job-task/${id}`, newDetails);

    return response;
}

export async function removeRiskJobTask(id: any) {
    return await apiDelete('core', `risk-job-task/${id}`);
}

export async function removeSiteRiskJobTask(id: any) {
    return await apiDelete('core', `site-job-task/${id}`);
}

export async function addRiskJobStep(newDetails: any) {
    const response = await apiPost('core', `risk-job-step`, newDetails);
    return response;
}

export async function updateRiskJobStep(newDetails: any, id?: string) {
    if (!id) {
        id = getUserDetails().client_id;
    }
    const response = await apiPut('core', `risk-job-step/${id}`, newDetails);

    return response;
}

export async function removeRiskJobStep(id: any) {
    return await apiDelete('core', `risk-job-step/${id}`);
}